import {ApplicationEnvironmentTypeEnum} from "../../env.configs.interface";

export const APP_ROOT_ELEMENT_ID = 'search-mask-root';

export interface IApplicationService {
    readonly isActive: boolean;
    readonly isInMobileView: boolean;
    readonly originalHeight: number;
    restoreOriginalHeight(): void;
    setCustomHeight(height: number): void;
    sendEnvironmentTypeEvent(environmentType: ApplicationEnvironmentTypeEnum): void;
}
